import { atom } from 'recoil';

export const prefixesFilterState = atom({
  key: 'prefixes_filter',
  default: {
    regionOptions: [],
    warehouseFilterOptions: [],
    typeOptions: [
      { label: 'Main', value: 1 }, // TODO: import config from filter file
      { label: 'Mobile Hub', value: 2 },
    ],
    selected: {},
    sort: {},
  },
});

export const userClonePrefixesState = atom({
  key: 'user_clone_filter_2',
  default: {
    selected: {
      owner_ids: null,
      owner_types: null,
      regions: null,
      q: null,
      page: null,
    },
    sort: { order_by: 'id', is_desc: true },
  },
});
